import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import MainContainer from "../../components/MainContainer";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import Heading from "../../components/Heading";
import BookingForm from "../../components/booking/BookingForm";
import "./Booking.css";
import queryString from "query-string";
import BookingStatusBadge from "../../components/booking/BookingStatusBadge";
import { ProfileType, BookingStatusType, BookingType } from "../../types/enum";
import moment from "moment";

import { Paper, Typography, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from "@material-ui/core";
@inject("profileStore", "bookingRequestStore", "templateStore")
@observer
class BookingProcess extends Component {

    constructor(props) {
        super(props);
        this.state = {
            titleHeader: "",
            isDuplicateBooking: false
        }
    }
    
    
    componentDidMount() {
        this.props.bookingRequestStore.resetBooking()
        let params = queryString.parse(this.props.location.search);
        if (!this.props.match.params.id) {
            this.props.bookingRequestStore.setBooking("dateStart", params.dateStart
                ? moment(params.dateStart, "DD-MM-YYYY")
                : moment().startOf("day"));
            var title = this.props.bookingRequestStore.setBookingHeading();
            this.setState({titleHeader: title})
            this.props.bookingRequestStore.setActId(params.actId);
            this.props.bookingRequestStore.setVenueId(params.venueId);
            this.props.bookingRequestStore.setVenueId(params.venueId);
            this.setState({
                isDuplicateBooking: params.duplicateBooking
            })
            
        }
    }

    getParameterByName = name => {
        var match = RegExp("[?&]" + name + "=([^&]*)").exec(this.props.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, " "));
    };

    getBookingStatus = () => {
        return "Draft";
    };

    render() {
        const { bookingHeading, limitBookingFeature } = this.props.bookingRequestStore;
        let renderWidgetContainerAction = () => (
            <Typography color="primary" variant="subheading" align="right">
                {this.getParameterByName("date")}
            </Typography>
        );

        return (
            <main>
                <Dialog open={!limitBookingFeature} disableBackdropClick disableEscapeKeyDown>
                    <DialogTitle>Booking Limit Reached</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            You have reached your limit for creating private bookings on the current plan. To create more bookings, please upgrade your plan.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.props.history.replace("/")} color="primary" variant="raised">
                            Go to Home
                        </Button>
                    </DialogActions>
                </Dialog>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Heading title={this.state.titleHeader}><div style={{ display: "inline-block" }}>
                        <BookingStatusBadge cancelledBy={0} status="Draft" />
                    </div></Heading>
                    <Paper className="org-paper-form">
                        <BookingForm
                            actId={this.getParameterByName("actId")}
                            venueId={this.getParameterByName("venueId")}
                            dateStart={this.getParameterByName("dateStart")}
                            dateEnd={this.getParameterByName("dateEnd")}
                            duplicateBooking={this.getParameterByName("duplicateBooking")}
                        />
                    </Paper>
                </MainContainer>
            </main>
        );
    }
}

export default BookingProcess;
